/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:05:34
 */ 
export const settleStepCn = {
    jcrzjg:"检测认证机构/公司：",
    qsrxgxx:"请输入相关信息",
    tyjgdm:"统一机构代码证：",
    qiyesuozaidi:"企业所在地：",
    jcrzfwgj:"检测认证服务国家(可多选)：",
    jcrzfwxm:"检测认证服务项目(可多选)：",
    gsclny:"公司成立年月：",
    xzrq:"选择日期",
    gszczb:"公司注册资本：",
    gsjj:"公司简介：",
    scsfz:"上传法人身份证扫描件：",
    scjcjgyyzz:"上传检测认证机构营业执照复印件（需盖公章）扫描件：",
    scjcjgzzzs:"上传检测认证资质证书扫描件：",
    scjjcl:"上传实验室/检测机构简介材料",
    scsmgdx:"上传检测机构平台注册账号经办人授权书：",
    xzsmgdx:"下载模板word文本，盖公章后上传",
    tianxieruzhuzl:'填写入驻资料',
    pingtaishenghe:'平台审核',
    ruzhuchenggong:'入驻成功',
    chenggongtijiaozl:'资料提交成功，请耐心等待平台审核',
    shengheshibaiqing:'审核失败,请重新填写注册信息并提交！',
    shengheyijian:'审核意见',
    chongxintainxie:'重新填写',
    gongxining:'恭喜您, 检测机构审核通过',
    gongxiningzj:'恭喜您, 专家审核通过',
    jinrujigouglht:'进入机构管理后台',
    jinruzjgouglht:'进入专家管理后台',
    qingshurujcjghm:'手机号码'
}


// WEBPACK FOOTER //
// ./src/lang/home/settleStep/indexCn.js